import { render, staticRenderFns } from "./ProjectsSwiper.vue?vue&type=template&id=26296ac2&"
import script from "./ProjectsSwiper.vue?vue&type=script&lang=js&"
export * from "./ProjectsSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsSwiper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports